

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// routes
import { GET_ALL_NOTIFICATION } from "../utils/routes";

// ---------------------------------------------------------------------------------

export const getNotification = createAsyncThunk(
  "notification/getNotification",
  async () => {
    return axios.get(GET_ALL_NOTIFICATION, { withCredentials: true });
  }
);

// ---------------------------------------------------------------------------------

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    loading: false,
    notificationData: [],
    selectedData: {},
    message: "",
    errMessage: "",
  },
  reducers: {
    resetMessage: (state) => {
      state.message = "";
    },
    resetErrMessage: (state) => {
      state.errMessage = "";
    },
    rowSelect: (state, action) => {
      state.selectedData = action?.payload.length > 0 && action?.payload[0];
    },
  },
  extraReducers: {
    [getNotification.pending]: (state, action) => {
      state.loading = true;
    },
    [getNotification.fulfilled]: (state, action) => {
      state.loading = false;
      state.notificationData = action?.payload?.data;
    },
    [getNotification.rejected]: (state, action) => {
      state.loading = false;
      state.error = action?.payload?.data?.message;
    },
  },
});

export const { resetMessage, resetErrMessage, rowSelect } = notificationSlice.actions;

export default notificationSlice.reducer;
